export default __webpack_public_path__ + "static/media/daidolife_logo_original.9e0dd59f.png";